<template>
  <div class="vx-row match-height" id="creat-product">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <vs-tab :label="$t('BasicInfo')">
            <form>
              <div class="vx-row mt-4">
                <div class="vx-col sm:w-3/4 w-full">
                  <div class="vx-row  mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("PersianName") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <input
                        v-model="productPersianName"
                        type="text"
                        list="productsPersian"
                        autocomplete="off"
                        name="persianName"
                        class="w-full p-2"
                        style="border: 1px solid #ccc;"
                      />
                      <datalist
                        id="productsPersian"
                        v-if="showListProductPersian"
                      >
                        <option
                          v-for="i in productListPersian"
                          :key="i"
                          :name="i.persianName"
                          :value="i.persianName"
                        ></option>
                      </datalist>
                      <!-- <vs-input
                        class="w-full"
                        v-model="model.persianName"
                        v-validate="{ required: true }"
                        name="persianName"
                      />-->
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('persianName')"
                        >{{ errors.first("persianName") }}</span
                      >
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("EnglishName") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <input
                        v-model="productEnglishName"
                        type="text"
                        list="productsEnglish"
                        autocomplete="off"
                        name="name"
                        class="w-full p-2"
                        style="border: 1px solid #ccc;"
                      />
                      <datalist
                        id="productsEnglish"
                        v-if="showListProductEnglish"
                      >
                        <option
                          v-for="i in productListEnglish"
                          :key="i"
                          :name="i.EnglishName"
                          :value="i.EnglishName"
                        ></option>
                      </datalist>
                      <!-- <vs-input
                        class="w-full"
                        v-model="model.name"
                        v-validate="{ required: true }"
                        name="name"
                      />-->
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('name')"
                        >{{ errors.first("name") }}</span
                      >
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("GenericProduct") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <v-select
                        label="name"
                        name="cat"
                        :options="allGenericProducts"
                        :reduce="x => x.id"
                        v-model="model.genericProductId"
                        v-validate="'required'"
                        dir="rtl"
                      >
                      </v-select>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('cat')"
                        >{{ errors.first("cat") }}</span
                      >
                    </div>
                  </div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("Brand") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <v-select
                        label="name"
                        name="brand"
                        :options="allBrands"
                        :reduce="x => x.id"
                        v-model="model.brandId"
                        v-validate="'required'"
                        dir="rtl"
                      >
                      </v-select>
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('brand')"
                        >{{ errors.first("brand") }}</span
                      >
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("Description") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <quill-editor
                        v-model="model.shortDescription"
                        :options="editorOption"
                        height="250"
                      >
                      </quill-editor>
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("Review") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <quill-editor
                        v-model="model.fullDescription"
                        :options="editorOption"
                        height="250"
                      >
                      </quill-editor>
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("MetaDescription") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input
                        class="w-full"
                        v-model="model.metaDescription"
                      />
                    </div>
                  </div>

                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("KeyWords") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input class="w-full" v-model="model.metaKeywords" />
                    </div>
                  </div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("Pros") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input class="w-full" v-model="model.pros" />
                    </div>
                  </div>
                  <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/4 w-full">
                      <b>{{ $t("Cons") }}</b>
                    </div>
                    <div class="vx-col sm:w-3/4 w-full">
                      <vs-input class="w-full" v-model="model.cons" />
                    </div>
                  </div>
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                  <div class="upload-wrapper">
                    <my-upload
                      field="img"
                      @crop-success="cropSuccess"
                      v-model="show"
                      :width="600"
                      :height="600"
                      langType="fa"
                      img-format="jpg"
                    ></my-upload>
                    <img :src="model.coverImage" v-if="model.coverImage" />
                  </div>

                  <a class="img-box" @click.prevent="toggleShow">
                    {{ $t("CoverImage")
                    }}<i class="material-icons notranslate">
                      cloud_upload
                    </i>
                  </a>
                </div>
                <div class="vx-row w-full">
                  <div class="vx-col w-full">
                    <vs-button
                      class="mr-3 mb-2 submit-btn bg_l_green"
                      @click.prevent="submitForm"
                      :disabled="disabled"
                      >{{ $t("Submit") }}</vs-button
                    >
                    <router-link
                      :to="{ path: '/ActualProduct/List' }"
                      class="vs-component vs-button back-btn"
                      color="rgb(62, 201, 214)"
                      type="filled"
                    >
                      {{ $t("BackToList") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </vs-tab>
          <vs-tab :label="$t('TechnicalSpecifications')" disabled> </vs-tab>
          <vs-tab :label="$t('Gallery')" disabled> </vs-tab>
          <vs-tab :label="$t('Events')" disabled> </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>

<style lang="scss">
#creat-product .bg_l_green {
  padding: 7.5px 24px !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import myUpload from "vue-image-crop-upload";

import { quillEditor } from "vue-quill-editor";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import "../../assets/scss/vuesax-rtl/pages/_custom.scss";
const dict = {
  custom: {
    persianName: {
      required: "لطفا نام فارسی را وارد نمایید."
    },
    name: {
      required: "لطفا نام انگلیسی را وارد نمایید."
    },
    cat: {
      required: "لطفا دسته‌بندی محصول را انتخاب نمایید."
    },
    brand: {
      required: "لطفا برند محصول را انتخاب نمایید."
    }
  }
};
Validator.localize("fa", dict);

export default {
  data() {
    return {
      modelSearchActual: {},
      newvaluePersian: "",
      oldvaluePersian: "",
      newvalueEnglish: "",
      oldvalueEnglish: "",
      productListPersian: [],
      productListEnglish: [],
      showListProductPersian: false,
      showListProductEnglish: false,
      productPersianName: "",
      productEnglishName: "",
      model: {
        persianName: "",
        name: "",
        brandId: null,
        genericProductId: null,
        shortDescription: "",
        coverImage: "",
        parentId: 0,
        status: 1,
        fullDescription: "",
        metaDescription: "",
        metaKeywords: "",
        pros: "",
        cons: ""
      },
      disabled: false,
      productImg: "",
      show: false,
      editorOption: {
        placeholder: ""
      }
    };
  },
  components: {
    "v-select": vSelect,
    quillEditor,
    "my-upload": myUpload
  },
  computed: {
    ...mapGetters({
      allBrands: "brand/list",
      allGenericProducts: "genericProduct/list"
    })
  },
  mounted() {
    this.fetchBrands();
    this.fetchGenericProducts();
  },
  methods: {
    ...mapActions({
      createActualProduct: "actualProduct/create",
      fetchBrands: "brand/fetchNoSkip",
      fetchGenericProducts: "genericProduct/fetchNoSkip",
      allActualProducts: "genericProduct/fetchSearchAllActualProducts"
    }),
    submitForm() {
      this.$validator.validateAll().then(result => {
        this.disabled = true;
        if (result) {
          this.model.persianName = this.productPersianName;
          this.model.name = this.productEnglishName;
          this.createActualProduct(this.model)
            .then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.$router.push("/ActualProduct/List");
              });
            })
            .catch(() => {
              this.disabled = false;
            });
        } else {
          // form have errors
          this.$swal({
            position: "center-center",
            type: "error",
            text: "خطا در ثبت رکورد!",
            showConfirmButton: false,
            timer: 2000
          });
          this.disabled = false;
        }
      });
    },
    cropSuccess(imgDataUrl) {
      this.model.coverImage = imgDataUrl;
    },
    /////
    toggleShow() {
      this.show = !this.show;
    }
  },
  watch: {
    productPersianName(val) {
      this.newvaluePersian = val;
      this.oldvaluePersian = val;
      setTimeout(() => {
        this.newvaluePersian = val;
        if (this.oldvaluePersian == this.newvaluePersian) {
          var testPersian = [];
          this.modelSearchActual = "persianName=" + this.productPersianName;
          this.allActualProducts(this.modelSearchActual).then(r => {
            r.forEach(function(element) {
              testPersian.push({
                id: element.id,
                persianName: element.persianName
              });
            });
            this.showListProductPersian = true;
            this.productListPersian = testPersian;
            this.modelSearchActual = {};
            this.productListEnglish = [];
          });
        }
      }, 2000);
    },
    productEnglishName(val) {
      this.newvalueEnglish = val;
      this.oldvalueEnglish = val;
      setTimeout(() => {
        this.newvalueEnglish = val;
        if (this.oldvalueEnglish == this.newvalueEnglish) {
          var testEnglish = [];
          this.modelSearchActual = "name=" + this.productEnglishName;
          this.allActualProducts(this.modelSearchActual).then(r => {
            r.forEach(function(element) {
              testEnglish.push({
                id: element.id,
                EnglishName: element.name
              });
            });
            this.showListProductEnglish = true;
            this.productListEnglish = testEnglish;
            this.modelSearchActual = {};
            this.productListPersian = [];
          });
        }
      }, 2000);
    }
  }
};
</script>
